var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoletosIconMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5945C18 19.9451 17.8622 20.2814 17.617 20.5294C17.3717 20.7774 17.0391 20.9167 16.6923 20.9167H2.30769C1.96087 20.9167 1.62825 20.7774 1.38301 20.5294C1.13777 20.2814 1 19.9451 1 19.5945V2.40557C1 2.05489 1.13777 1.71858 1.38301 1.47061C1.62825 1.22265 1.96087 1.08334 2.30769 1.08334H11.574C11.9206 1.08342 12.253 1.2226 12.4981 1.47031L17.6173 6.64637C17.8623 6.89424 17.9999 7.23031 18 7.58074V19.5945Z",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.291 7.45834H12.191C11.8529 7.45834 11.5286 7.32401 11.2895 7.0849C11.0503 6.8458 10.916 6.52149 10.916 6.18334V1.08334",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00587 10.298C4.19199 10.5258 4.4343 10.7084 4.71227 10.8304C4.99024 10.9524 5.29566 11.0101 5.60267 10.9987C6.58155 10.9987 7.37565 10.4437 7.37565 9.75983C7.37565 9.07594 6.58413 8.52177 5.60611 8.52177C4.62809 8.52177 3.83398 7.9668 3.83398 7.2821C3.83398 6.5974 4.62809 6.04324 5.60611 6.04324C5.91314 6.03164 6.21864 6.08929 6.49665 6.21129C6.77465 6.33328 7.01693 6.51601 7.20291 6.74395",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79102 13.1249H14.4577",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54102 17.3748H14.4577",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoletosIconMenu);
export default __webpack_public_path__ + "static/media/boletos-icon-menu.7e98678e38279edcfe0dd67e3bf9b83b.svg";
export { ForwardRef as ReactComponent };